import React from "react";
import { Link, Stack, SxProps, Typography, TypographyProps } from "@mui/material";
import PosterImage, { PosterImageProps } from "../../../Misc/PosterImage";
import { ObjectType } from "../../../../Core/Api/Types/object-type";
import AssetThumbnail from "../../../Misc/AssetThumbnail";
import { Link as RouterLink } from "react-router";
import { GetTitleRouterPath } from "../../../../Utils/helpers";

export type TitleItemProps = {
  titleId?: number;
  poster?: string;
  posterProps?: Partial<PosterImageProps>;
  title: string;
  titleProps?: Partial<TypographyProps>;
  size?: "small" | "large";
  desc?: string;
  children?: React.ReactNode;
  rightContent?: React.ReactNode;
  sx?: SxProps;
  disableNavigation?: boolean;
};

const TitleItem: React.FC<TitleItemProps> = (props) => {
  const {
    titleId,
    title,
    poster,
    posterProps,
    titleProps,
    desc,
    children,
    size = "large",
    rightContent,
    disableNavigation = false,
    ...otherProps
  } = props;

  return (
    <Stack spacing={1.5} direction="row" alignItems="center" {...otherProps}>
      {poster === "asset" ? (
        <Stack>
          <AssetThumbnail type={ObjectType.Audio} />
        </Stack>
      ) : (
        <>
          {poster && (
            <PosterImage
              width={36}
              height={48}
              borderRadius="2px"
              flexShrink={0}
              img={{ src: poster }}
              {...posterProps}
            />
          )}
        </>
      )}

      <Stack alignItems="flex-start">
        {titleId ? (
          <>
            {disableNavigation ? (
              <Typography
                variant={size === "large" ? "subtitle2" : "body1"}
                fontWeight={size === "large" ? 600 : 500}
                {...titleProps}
              >
                {title}
              </Typography>
            ) : (
              <Link
                component={RouterLink}
                underline="hover"
                color="text.primary"
                to={`${GetTitleRouterPath()}/${titleId}`}
              >
                <Typography
                  variant={size === "large" ? "subtitle2" : "body1"}
                  fontWeight={size === "large" ? 600 : 500}
                  {...titleProps}
                >
                  {title}
                </Typography>
              </Link>
            )}
          </>
        ) : (
          <Typography
            variant={size === "large" ? "subtitle2" : "body1"}
            fontWeight={size === "large" ? 600 : 500}
            mb={0.5}
            {...titleProps}
          >
            {title}
          </Typography>
        )}

        {desc && (
          <Typography color="text.tier" sx={(theme) => ({ ...theme.helpers(theme).clampedText })}>
            {desc}
          </Typography>
        )}
        {children}
      </Stack>
      {rightContent}
    </Stack>
  );
};

export default TitleItem;
